import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["error"]
  static values = {
    type: String
  }

  validate(event) {
    this.clearErrors()

    const type = this.typeValue
    let valid = true

    if (type === "salary_reveal") {
      const hiddenField = this.element.querySelector('input[name="job_role_id"]')
      if (!hiddenField || !hiddenField.value) {
        this.showError("Please select a job role")
        valid = false
      }
    }

    if (type === "salary_ranking") {
      const hiddenFields = this.element.querySelectorAll('input[name="job_role_ids[]"]')
      if (hiddenFields.length < 3) {
        this.showError(`Please select at least 3 roles (${hiddenFields.length} selected)`)
        valid = false
      } else {
        const withData = Array.from(hiddenFields).filter(
          f => f.dataset.hasSalaryData === "true"
        ).length
        if (withData < 3) {
          this.showError(
            `At least 3 roles with salary data are required. Currently ${withData} of ${hiddenFields.length} selected roles have data.`
          )
          valid = false
        }
      }
    }

    if (type === "tax_breakdown") {
      const salaryInput = this.element.querySelector('input[name="salary"]')
      if (salaryInput) {
        const salary = parseInt(salaryInput.value, 10)
        if (!salary || salary < 20000 || salary > 500000) {
          this.showError("Salary must be between $20,000 and $500,000")
          valid = false
        }
      }
    }

    if (type === "tax_poster") {
      const modeSelect = this.element.querySelector('select[name="poster_mode"]')
      const salaryInput = this.element.querySelector('input[name="salary"]')
      if (modeSelect && modeSelect.value === "breakdown" && salaryInput) {
        const salary = parseInt(salaryInput.value, 10)
        if (!salary || salary < 20000 || salary > 500000) {
          this.showError("Salary must be between $20,000 and $500,000")
          valid = false
        }
      }
    }

    if (type === "take_home_ladder") {
      const salaryInputs = Array.from(this.element.querySelectorAll('input[name^="salary_"]'))
      const filled = salaryInputs.filter(f => f.value.trim() !== "")
      if (filled.length < 2) {
        this.showError("Please provide at least 2 salaries")
        valid = false
      } else {
        const outOfRange = filled.some(f => {
          const salary = parseInt(f.value, 10)
          return !salary || salary < 20000 || salary > 500000
        })
        if (outOfRange) {
          this.showError("Each salary must be between $20,000 and $500,000")
          valid = false
        }
      }
    }

    if (type === "calculator_demo") {
      const salaryInput = this.element.querySelector('input[name="salary"]')
      if (salaryInput) {
        const salary = parseInt(salaryInput.value, 10)
        if (!salary || salary < 20000 || salary > 500000) {
          this.showError("Salary must be between $20,000 and $500,000")
          valid = false
        }
      }
    }

    if (!valid) {
      event.preventDefault()
    }
  }

  showError(message) {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = message
      this.errorTarget.classList.remove("hidden")
    }
  }

  clearErrors() {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = ""
      this.errorTarget.classList.add("hidden")
    }
  }
}
